export enum MigrationStatus {
  Dealers = 'Dealers',
  Migrated = 'Migrated'
}

export enum MigrationType {
  Core = 'Core',
  TireRim = 'TireRim'
}
